import baseApi from '@store/api/baseApi';

import { toastError, toastSuccess } from '@/components/Toast';
import { closeLoader, openLoader } from '@/store/actions/LoaderAction';

export const commonApis = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getAllUser: builder.query({
			query: ({ params }) => ({
				url: `user/find-list-by-email-and-user-type`,
				params
			}),
			keepUnusedDataFor: 30000, // 30 seconds for caching
			providesTags: ['UserByUserTypes']
		}),
		getUserByType: builder.query({
			query: ({ params }) => ({
				url: `user/by-user-types`,
				params
			})
		}),
		getAllBrands: builder.query({
			query: ({ params }) => ({
				url: 'brand/allWithLogo',
				params
			}),
			keepUnusedDataFor: 30000, // 30 seconds for caching
			providesTags: ['BrandsList'],
			transformResponse: (response) => {
				if (response) {
					return response?.data?.map((brand) => ({
						...brand,
						value: brand.name
					}));
				}
				return response;
			}
		}),
		mixPanelTrakingEvent: builder.mutation({
			query: ({ body, params, type = '' }) => ({
				url: `mixpanel/event/add/${type}`,
				method: 'POST',
				body,
				params
			})
		}),
		// Currently used in Range plan table
		reviewCosting: builder.mutation({
			query: ({ entityId, params }) => ({
				url: `range-planning/${entityId}/costing-assessment`,
				method: 'POST',
				params
			}),
			async onQueryStarted(_args, { queryFulfilled, dispatch }) {
				try {
					dispatch(openLoader());
					const { data } = await queryFulfilled;

					toastSuccess(data?.message);
				} catch ({ error }) {
					toastError(error?.data?.error || 'Something went wrong!');
				} finally {
					dispatch(closeLoader());
				}
			}
		}),
		getPersonalSettings: builder.query({
			query: ({ settingKey, params }) => ({
				url: `personal-setting/get/${settingKey}`,
				params
			}),
			keepUnusedDataFor: 0
		}),
		addPersonalSetting: builder.mutation({
			query: ({ body }) => ({
				url: `personal-setting/set`,
				method: 'POST',
				body
			})
		}),
		// Common Tags *use this for all types of tags just pass params as required
		getTags: builder.query({
			query: ({ params }) => ({
				url: 'tags/all',
				method: 'GET',
				params
			})
		}),
		// Get  Product Artboard sold tags (used in collection details page and folder details page)
		artboardProductTag: builder.mutation({
			query: (productIds) => ({
				url: `/artwork-artboard/products`,
				method: 'POST',
				body: [...productIds]
			})
		}),
		// Remove Files/Image
		removeDoc: builder.mutation({
			query: ({ docId }) => ({
				url: `/doc/${docId}`,
				method: 'DELETE'
			})
		}),
		// Get Presentation PSD files
		getPresentationPSDFiles: builder.mutation({
			query: ({ params, body }) => ({
				url: `/archived-doc/product`,
				method: 'POST',
				body,
				params
			})
		})
	})
});

export const {
	useGetAllUserQuery,
	useGetAllBrandsQuery,
	useLazyGetAllUserQuery,
	useGetUserByTypeQuery,
	useMixPanelTrakingEventMutation,
	useReviewCostingMutation,
	useGetPersonalSettingsQuery,
	useAddPersonalSettingMutation,
	useGetTagsQuery,
	useArtboardProductTagMutation,
	useRemoveDocMutation,
	useGetPresentationPSDFilesMutation
} = commonApis;
